import { jsx as _jsx } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { sanitizeString } from '@sm/utils';
import { Checkbox } from '@wds/checkbox';
import { splitBySearchPhrase } from '../../../lib';
const useStyles = createUseStyles(theme => {
  return {
    label: {
      fontSize: theme.type.fontSize.bodySm
    }
  };
});
const ThemeRow = ({
  theme,
  responseTextId,
  search
}) => {
  const classes = useStyles();
  const items = splitBySearchPhrase({
    text: theme.theme,
    searchPhrase: search
  });
  const label = items.reduce((htmlString, item) => {
    const makeBold = item.toLowerCase() === search.toLowerCase();
    return `${htmlString}${makeBold ? `<b>${item}</b>` : `<span>${item}</span>`}`;
  }, '');
  return _jsx(Checkbox, {
    id: `${theme.id}-${responseTextId}`,
    checked: theme.checked,
    label: _jsx("span", {
      id: `ThemeRow__Theme-${theme.id}`,
      "data-testid": `ThemeRow__Theme-${theme.id}`,
      className: classes.label,
      dangerouslySetInnerHTML: {
        __html: sanitizeString(label)
      }
    })
  });
};
export default ThemeRow;